var loadedGA = false;
window.gtag = undefined;

function innitGA(gTAG_ID)
{
    window.dataLayer = window.dataLayer || [];
    window.gtag = function(){
        window.dataLayer.push(arguments);
    }
    window.gtag('js', new Date());
    window.gtag('config', gTAG_ID);
}
function loadGA(gTAG_ID)
{
    var hostname = 'https://www.googletagmanager.com/gtag/js';
    var js = document.createElement('script');
    js.setAttribute('type', 'text/javascript');
    js.setAttribute('src', hostname+'?id='+gTAG_ID);
    document.head.appendChild(js);
    loadedGA = false; // so use a boolean
    js.onreadystatechange = function () {
        if (js.readyState == 'loaded') 
        { 
            if(!loadedGA)
            {
                innitGA(gTAG_ID);
            }
            loadedGA = true;
        }
    };
    js.onload = function () 
    {
        if(!loadedGA)
        {           
            innitGA(gTAG_ID);
        }
        loadedGA = true;
    };
}

export default loadGA;